import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../Common/LoadingSpinner';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [courseData, setCourseData] = useState(null);

  useEffect(() => {
    const courseId = searchParams.get('courseId');
    const paymentId = searchParams.get('paymentId');

    // Fetch course details to show in success message
    const fetchCourseData = async () => {
      try {
        if (courseId) {
          const response = await axios.get(`/api/courses/${courseId}`);
          setCourseData(response.data);
        }
      } catch (error) {
        console.error('Error fetching course:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseData();
    toast.success('Payment successful! You are now enrolled in the course.');

    const t = setTimeout(() => {
      navigate('/my-courses');
    }, 4000);

    return () => clearTimeout(t);
  }, [searchParams, navigate]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="max-w-md w-full">
        <div className="card text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-green-100 rounded-full p-3">
              <CheckCircleIcon className="h-12 w-12 text-green-600" />
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h2>
          
          <p className="text-gray-600 mb-6">
            Thank you for your payment. You are now enrolled in:
          </p>

          {courseData && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h3 className="font-semibold text-lg text-blue-900 mb-1">
                {courseData.title}
              </h3>
              <p className="text-sm text-blue-700">{courseData.courseCode}</p>
              <p className="text-sm text-blue-600 mt-2">
                Amount Paid: ₹{courseData.fees}
              </p>
            </div>
          )}

          <div className="space-y-2 text-sm text-gray-500">
            <p>✓ Course access has been granted</p>
            <p>✓ You can start learning immediately</p>
            <p className="mt-4 text-gray-400">Redirecting to My Courses in a few seconds...</p>
          </div>

          <button
            onClick={() => navigate('/my-courses')}
            className="mt-6 btn btn-primary w-full"
          >
            Go to My Courses
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
